import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ApplicationService } from 'app-shell-data';
import { DrawerComponent } from 'common-ui';
import { ElementResizeDirective } from 'common-util';
import { AppActionsMainRenderTargetComponent } from '../../render-targets/app-actions-main/app-actions-main-render-target.component';
import { AppActionsSecondaryRenderTargetComponent } from '../../render-targets/app-actions-secondary/app-actions-secondary-render-target.component';
import { AppToolbarRenderTargetComponent } from '../../render-targets/app-toolbar/app-toolbar-render-target.component';
import { AppHeaderHandleComponent } from './components/app-header-handle/app-header-handle.component';
import { AppHeaderLogoComponent } from './components/app-header-logo/app-header-logo.component';
import { AppHeaderMenuButtonComponent } from './components/app-header-menu-button/app-header-menu-button.component';

@Component({
  selector: 'ideal-app-header',
  standalone: true,
  imports: [
    DrawerComponent,
    ElementResizeDirective,
    MatToolbarModule,
    // AppHeaderWedgeContainerComponent,
    AppHeaderHandleComponent,
    MatButtonModule,
    MatIconModule,
    AppHeaderMenuButtonComponent,
    AppHeaderLogoComponent,
    AppToolbarRenderTargetComponent,
    AppActionsMainRenderTargetComponent,
    AppActionsSecondaryRenderTargetComponent,
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppHeaderComponent {
  private readonly _store = inject(ApplicationService);

  readonly drawerHeight = output<number>();

  protected menuIsOpen = this._store.menu.isOpen;

  protected toggleMenu() {
    this._store.menu.toggle();
  }

  protected readonly headerHidden = this._store.header.isHeaderHidden;
  protected readonly hideHeaderOnScrollEnabled = this._store.header.hideOnScrollEnabled;

  protected toggleHeaderHidden() {
    this._store.header.toggleHeader();
  }
}
